import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ServiceWorkerService, UserTrackingService } from '@takectrl-multiapp/svcs-core';
import { QuoteRequestStatusType, SharedConfig } from '@takectrl-multiapp/svcs-share-config';
import { UIAppInitializationService } from '../../services/ui-app-initialization.service';
import { BUSNQuoteScheduleService, BUSNThirdPartyService, BUSNUserService } from '@takectrl-multiapp/svcs-core-business';

declare const dataLayer: any[];

@Component({
  selector: 'login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit {
  showOTPScreen = false;
  @Output() navigateForceUpdateScreen: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateHomeQuote: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navigateHomeWallet: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navForgotPasswordPage: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navigateSignUpPage: EventEmitter<unknown> = new EventEmitter<unknown>();

  constructor(
    private readonly userTrackingService: UserTrackingService,
    public userService: BUSNUserService,
    public sharedConfig: SharedConfig,
    private readonly serviceWorkerService: ServiceWorkerService,
    public uiAppInitializationService: UIAppInitializationService,
    public busnThirdPartyService: BUSNThirdPartyService,
    private readonly busnQuoteScheduleService: BUSNQuoteScheduleService
  ) {}

  async ngOnInit() {
    this.sharedConfig.setShowCustomLoader(true);
    // this.serviceWorkerService.init();
  }

  async ngAfterViewInit(): Promise<void> {
    this.userTrackingService.init();
    this.uiAppInitializationService.getAppSettings();
    this.sharedConfig.setShowCustomLoader(false);

    this.busnThirdPartyService.logEvent('page_login');
    if (!SharedConfig.routeParamUserMsisdn && SharedConfig.routeParamUserEmail && !SharedConfig.routeParamUserEmailQuoteOnBehalf) {
      this.setupViaEmail();
    }

    dataLayer.push({
      event: 'page_show',
      screenPath: 'login',
      screenName: 'login',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  async routeUserToCorrectHomePage() {
    let activeQuoteRequest = null;
    let openQuoteRequest = null;
    let quote_request = await this.busnQuoteScheduleService.getQuoteRequestsCurrent()
    let active_schedules = await this.busnQuoteScheduleService.getAllActiveSchedules()
    if (quote_request) {
      activeQuoteRequest = quote_request.find(
        (x) =>
          x.status === QuoteRequestStatusType.Submitted ||
          x.status === QuoteRequestStatusType.WaitingOnQuotes ||
          x.status === QuoteRequestStatusType.WaitingToAccept
      );
      openQuoteRequest = quote_request.find(
        (x) => x.status === QuoteRequestStatusType.Open || x.status === QuoteRequestStatusType.Cancelled
      );
    }

    if (
      (active_schedules?.length === 0 && activeQuoteRequest) ||
      SharedConfig.quoteRequest?.status === QuoteRequestStatusType.WaitingToAccept ||
      SharedConfig.quoteRequest?.status === QuoteRequestStatusType.WaitingOnQuotes
    ) {
      this.navigateHomeQuote.emit();
    } else if (active_schedules?.length > 0 || (active_schedules?.length === 0 && openQuoteRequest)) {
      this.navigateHomeWallet.emit();
    } else {
      this.navigateHomeWallet.emit();
    }
  }

  resetPassword() {
    this.navForgotPasswordPage.emit();
  }

  setupViaEmail() {
    this.userService.resetPassword(SharedConfig.routeParamUserEmail);
    this.navForgotPasswordPage.emit();
  }

  forgotPassword() {
    this.navForgotPasswordPage.emit();
  }

  async signUp() {
    this.navigateSignUpPage.emit();
  }

  async clearLocalStorage() {
    SharedConfig.clearSharedConfig();
    await localStorage.removeItem('userEmail');
  }
}
